import { Fragment, useCallback, useMemo, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { SendEmailService } from '../../../service/invoice/SendEmailService';

import { useDataTable } from '../../../shared/hooks/DataTable';
import { useTranslation } from '../../../shared/language';

const EmailHistoryTable = ({ selectedItem }) => {
  const { t } = useTranslation();
  const invoiceId = selectedItem.id || selectedItem.invoiceId;
  const requiredParams = useMemo(() => ({ invoiceId }), [invoiceId]);

  const appendData = useCallback(async (params) => {
    const data = await SendEmailService.getList(params);
    const modifiedData = data.items.map(item => ({
      ...item,
      invoiceNo: selectedItem.invoiceNumber,
      invoiceDate: selectedItem.invoiceDate
    }));
    return {
      ...data,
      items: modifiedData
    };
  }, [selectedItem.invoiceNumber, selectedItem.invoiceDate]);

  const { render: renderDataTable } = useDataTable({
    columns: [
      { field: 'invoiceSerial', header: t('common.symbol'), width: 90 },
      { field: 'invoiceNo', header: t('common.invoiceNo'), width: 100 },
      { field: 'invoiceDate', header: t('common.invoiceDate'), width: 110, dataType: 'date' },
      { field: 'emailTo', header: t('common.customerEmail'), minWidth: 160 },
      { field: 'dateSendEmail', header: t('common.sentDate'), width: 140, dataType: 'date-time' },
      { field: 'statusName', header: t('common.sentStatus'), width: 120 },
      { field: 'errorMessage', header: t('common.error'), width: 180 },
      {
        field: 'isWatched', header: t('common.view'), width: 60, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.isWatched) {
            return <span className={`ss04-status invoice-status-0 pi pi-eye mr-3`} title={t('common.viewed')}></span>;
          }
          return <span className={`ss04-status invoice-status-1 pi pi-eye-slash mr-3`} title={t('common.notViewed')}></span>;
        }
      }
    ],
    indexColumnWidth: 40,
    getList: appendData,
    rows: 20,
    requiredParams
  });

  return renderDataTable();
};

export const DialogSentEmail = (props) => {
  const { t } = useTranslation();

  const { selectedItem } = props;

  const [display, setDisplay] = useState(false);

  const handleOpenHistory = () => {
    setDisplay(true);
  };

  const handleCloseHistory = () => {
    setDisplay(false);
  };

  return (
    <Fragment>
      <div className="field grid">
        <div className="col-12 md:col-12">
          <b className="p-link" onClick={handleOpenHistory}>{t('common.checkEmailHistory')}</b>
        </div>
      </div>
      <Dialog header={t('common.invoiceEmailHistory')} visible={display} style={{ width: '80rem' }} position="top" onHide={handleCloseHistory}>
        {display && <EmailHistoryTable selectedItem={selectedItem} />}
        <div className="flex justify-content-end">
          <Button label={t('common.close')} icon="pi pi-times" onClick={handleCloseHistory} className="p-button-text p-button-sm" />
        </div>
      </Dialog>
    </Fragment>
  );
}
